module.exports = __webpack_public_path__ + "img/9788932918839.610b9225.jpg";